import { useLocation } from "react-router";
import AirxContactSection from "../AirxContactSection/AirxContactSection";
import MapView from "../MapView/MapView";
import QuoteLineForm from "../QuoteLineForm/QuoteLineForm";
import HeaderAddress from "../HeaderAddress/HeaderAddress";
import QuoteLineHeader from "../QuoteLineHeader/QuoteLineHeader";

export default function SingleQuoteView() {
  const locationState = useLocation().state;
  return (
    <div>
      <div>
        <QuoteLineHeader
          RFSdate={locationState?.generalQuoteData?.RFSdate}
          dueDate={locationState?.generalQuoteData?.dueDate}
          createdAt={null}
          customerName={null}
          customerProjectNumber={
            locationState?.generalQuoteData?.customerProjectNumber
          }
          endCustomerName={locationState?.generalQuoteData?.endCustomerName}
          localContactName={null}
          localContactNumber={null}
          key={"Quote line from quote req"}
        />
      </div>

      <div className="flex gap-4 h-[330px] overflow-hidden w-full">
        <div className="flex flex-col gap-4 bg-white rounded-lg w-full">
          <div className="flex justify-between gap-4">
            <HeaderAddress
              addressAData={locationState?.pickedAddress?.pickedAAddress}
              addressBData={locationState?.pickedAddress?.pickedBAddress}
              generalQuoteData={locationState?.generalQuoteData}
            />
          </div>
          <div className="px-4 pb-4 rounded-lg w-full">
            <MapView
              addressAData={locationState?.pickedAddress.pickedAAddress}
              addressBData={locationState?.pickedAddress?.pickedBAddress}
            />
          </div>
        </div>
        <AirxContactSection source={"customer"} />
      </div>
      <div className=" mt-5 rounded-lg">
        <QuoteLineForm
          quoteGeneralData={locationState.generalQuoteData}
          quoteLineId={locationState.quoteLine.id}
          productType={locationState.productName}
          data={locationState.quoteLine.price}
          quoteType={locationState.quoteLine.quoteType}
        />
      </div>
    </div>
  );
}
